import type { AgencyUsagePeriod } from '~/api/graphql';
import { formatUsagePeriodRange } from './usage-utils';

type UsagePeriodHeaderProps = {
  period: AgencyUsagePeriod | null | undefined;
  timezone: string;
};

export const UsagePeriodHeader = ({ period, timezone }: UsagePeriodHeaderProps) => {
  const rangeLabel =
    period != null ? formatUsagePeriodRange(period.start, period.end, timezone) : null;

  return (
    <div className="min-w-0">
      <h3 className="m-0 p-0 text-lg font-medium text-neutral-900 dark:text-white">
        Current billing period
      </h3>
      {rangeLabel ? (
        <p className="mt-1 text-sm text-neutral-500 dark:text-neutral-400">{rangeLabel}</p>
      ) : (
        <p className="mt-1 text-sm text-neutral-500 dark:text-neutral-400">
          Billing period unavailable
        </p>
      )}
    </div>
  );
};
